import { App } from "./app";
import "./styles/global.css";
import "./styles/menu.css";
import "./styles/menu-responsive.css";
import "./styles/game.css";
import "./styles/color-picker.css";
import "./styles/ads.css";

const root = document.getElementById("app");

if (!root) {
  throw new Error("App root element was not found");
}

const app = new App(root);
app.start();